import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
import { Currency } from './../model';
import { AppContext } from './app-context.service';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  hostUrl = '';
  sessionKey = '';
  ongoingRequests = 0;
  showLoader: BehaviorSubject<any> = new BehaviorSubject(false);

  constructor(private http: HttpClient, private appContext: AppContext) {
    this.hostUrl = environment.apiUrl;
  }


  get userCurrency(): Currency | undefined {
    return this.appContext.currency;
  }

  getCurrencyList(): Observable<any> {
    return this.appContext.getCurrencyList();
  }

  changeCurrency(currencySelected : any) {

    return this.http
      .get(`api/context/changecurrency/${currencySelected}`)
      .pipe(
        map(res => {
          this.appContext.setCurrency(currencySelected);
          return { currencyCode: currencySelected };
        })
      );
  }
}
